import React, { useEffect } from 'react';
import { NsColumn } from '@britishgasenergy/react-nucleus';

import { NsIcon } from 'components/common/ns-icon/NsIcon';
import { NsCard } from 'components/common/ns-card/NsCard';
import { useRevampJourney } from 'hooks/useRevampJourney';

export const testId = 'stopGapTestId';

export const NsStopgap = () => {
  const { isRevampJourney } = useRevampJourney();
  const Wrapper = isRevampJourney ? NsCard : React.Fragment;
  const wrapperProps = isRevampJourney ? { testId } : {};
  const columnProps = !isRevampJourney ? { 'data-testid': testId } : {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrapper {...wrapperProps}>
      <NsColumn
        tennis-court="1"
        basketball-court="1"
        hockey-pitch="3"
        {...columnProps}
      >
        <div>&nbsp;</div>
        <table>
          <tbody>
            <tr>
              <td align="center">
                <br />
                <br />
                <br />
                <NsIcon type="loading" size="4" />
                <br />
                <br />
                <br />
                <br />
              </td>
            </tr>
          </tbody>
        </table>
        <div>&nbsp;</div>
      </NsColumn>
    </Wrapper>
  );
};
